import { render, staticRenderFns } from "./TriangleLink.vue?vue&type=template&id=fba29a64&scoped=true&lang=pug&"
import script from "./TriangleLink.vue?vue&type=script&lang=ts&"
export * from "./TriangleLink.vue?vue&type=script&lang=ts&"
import style0 from "./TriangleLink.vue?vue&type=style&index=0&id=fba29a64&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba29a64",
  null
  
)

export default component.exports